import { render, staticRenderFns } from "./SimpleRow.vue?vue&type=template&id=cf4cb732"
import script from "./SimpleRow.vue?vue&type=script&lang=js"
export * from "./SimpleRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports